<h2 mat-dialog-title *ngIf="editTruckType.id === undefined">
  <i class="fas fa-plus me-2"></i>Create Truck Type
</h2>
<h2 mat-dialog-title *ngIf="editTruckType.id !== undefined">
  <i class="fas fa-plus me-2"></i>Edit Truck Type for {{ editTruckType.name }}
</h2>
<mat-dialog-content class="mat-typography">
  <form #TruckTypeForm="ngForm" id="TruckTypeForm" name="TruckTypeForm">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="name"
              name="name"
              [(ngModel)]="editTruckType.name"
              placeholder="Name"
              required
              #name="ngModel"
            />
          </mat-form-field>
        
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="description"
              name="description"
              [(ngModel)]="editTruckType.description"
              placeholder="Description"
              required
              #description="ngModel"
            />
          </mat-form-field>
         
        </div>
      </div>
    </div>
    <div class="row mb-3" *ngIf="editTruckType.id === undefined">
      <div class="col-lg-2 col-12">
        <mat-checkbox
          name="isActive"
          id="isActive"
          [(ngModel)]="editTruckType.isActive"
          color="primary"
        >
          Active
        </mat-checkbox>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
   <div class="custom-dialog-actions">
    <div class="btn-group">
      <button *ngIf="!submitting" type="submit" form="TruckTypeForm" class="custom-button save-button"
        [disabled]="TruckTypeForm.invalid" (click)="onSubmit()">
        <span class="fa-icon-wrapper"><i class="fas fa-save"></i></span>Save
      </button>
      <mat-spinner *ngIf="submitting" [diameter]="20"></mat-spinner>
      <button class="custom-button cancel-button" (click)="cancelClicked(TruckTypeForm, false)">
        <span class="fa-icon-wrapper"><i class="fas fa-times"></i></span>Cancel
      </button>
    </div>
   
  </div>
</mat-dialog-actions>
